var map = {
	"./calculator.svg": 220,
	"./excel.svg": 221,
	"./exception_frame.png": 222,
	"./exception_frame.svg": 223,
	"./no_calculator.svg": 224,
	"./no_disconnect.svg": 225,
	"./no_headphones.svg": 226,
	"./no_instant_messaging.svg": 227,
	"./no_internet_browsing.svg": 228,
	"./no_leaving_camera.svg": 229,
	"./no_local_browsing.svg": 230,
	"./no_materials.svg": 231,
	"./no_pause.svg": 232,
	"./no_people_in_room.svg": 233,
	"./no_phone.svg": 234,
	"./no_tv_radio.svg": 235,
	"./notes.svg": 236,
	"./pdf.svg": 237,
	"./people_with_interaction.svg": 238,
	"./people_without_interaction.svg": 239,
	"./powerpoint.svg": 240,
	"./rule_frame.png": 241,
	"./rule_frame.svg": 242,
	"./specific_websites.svg": 243,
	"./textbooks.svg": 244,
	"./word.svg": 245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;